let server: any = "";

if (process.env.NODE_ENV == "development") {
    server = process.env.REACT_APP_API
} else {
    //@ts-ignore
    server = window._env_.REACT_APP_API;
}

export { server };